/**
 * @generated SignedSource<<25b21dc116952fe5e12ec601666979fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type aiConsultDetailUpdateChatMutation$variables = {
  chatHistory: string;
  linkparameter: string;
};
export type aiConsultDetailUpdateChatMutation$data = {
  readonly update_request_ai_consult_detail: {
    readonly affected_rows: number;
  } | null | undefined;
};
export type aiConsultDetailUpdateChatMutation = {
  response: aiConsultDetailUpdateChatMutation$data;
  variables: aiConsultDetailUpdateChatMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chatHistory"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "linkparameter"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "chatHistory",
            "variableName": "chatHistory"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "linkparameter"
              }
            ],
            "kind": "ObjectValue",
            "name": "linkparameter"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "request_ai_consult_detail_mutation_response",
    "kind": "LinkedField",
    "name": "update_request_ai_consult_detail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affected_rows",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiConsultDetailUpdateChatMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiConsultDetailUpdateChatMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "cfa20b6692564e7572a25df7aa054b59",
    "id": null,
    "metadata": {},
    "name": "aiConsultDetailUpdateChatMutation",
    "operationKind": "mutation",
    "text": "mutation aiConsultDetailUpdateChatMutation(\n  $linkparameter: String!\n  $chatHistory: String!\n) {\n  update_request_ai_consult_detail(where: {linkparameter: {_eq: $linkparameter}}, _set: {chatHistory: $chatHistory}) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "615cb0eee3eb70e9ced5ea02bc70cb26";

export default node;
